"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseExperience = void 0;
var React = __importStar(require("react"));
var ExperienceRouterContext_1 = __importStar(require("./ExperienceRouterContext"));
exports.parseExperience = function (header) {
    if (header === void 0) { header = ExperienceRouterContext_1.Experience.DoorDash; }
    var experienceValues = Object.keys(ExperienceRouterContext_1.Experience).map(function (exp) { return exp.toLowerCase(); });
    return experienceValues.indexOf(header) !== -1
        ? header
        : ExperienceRouterContext_1.Experience.DoorDash;
};
var ExperienceRouter = function (_a) {
    var children = _a.children, _b = _a.experience, experience = _b === void 0 ? ExperienceRouterContext_1.Experience.DoorDash : _b;
    return (React.createElement(ExperienceRouterContext_1.default.Provider, { value: { experience: exports.parseExperience(experience) } }, children));
};
exports.default = ExperienceRouter;
